var _g, _g2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconTickBackground(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Ellipse 31",
    fill: "var(--bgColour, #9dad98)",
    stroke: "var(--bgColour, #9dad98)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 13,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 12.5,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.001 4)",
    clipPath: "url(#icon-tick-background_svg__a)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "tick",
    fill: "var(--fgColour, #fff)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 101",
    d: "M2.763 7.644l5.342 5.342-1.577 1.577-5.342-5.342z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 102",
    d: "M17.484 4.927L7.241 15.17l-1.682-1.682L15.802 3.245z"
  })))));
}

export default __webpack_public_path__ + "4d2c7d736e28da30d26c6befc89e7d2c.svg";
export { SvgIconTickBackground as ReactComponent };